import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { useFormContainerContext } from '../../../../context/formContainerContext';
import { getObjectValueByStringPath } from '../../../../utils/system';
import { getFormVariable, prepareInputData } from '../../utils';
import type { IFormTypeProps } from '../../../../types';

export const Text = ({ params, className = '', type = 'text', onChange, registerOptions, icon, handleClickIcon }: IFormTypeProps) => {
  const { name, disabled, label, validate, ...args } = params;
  const { maxLength, required, placeholder, valueAsNumber, pattern, defaultValue } = getFormVariable(args);
  const {
    register,
    formState: { errors },
    trigger,
    setValue,
  } = useFormContext();
  const { isFormLoading, isFormSubmitted } = useFormContainerContext();

  const isDisabled = !!disabled || isFormLoading || isFormSubmitted;

  const objectValue = getObjectValueByStringPath(errors, name);

  return (
    <>
      <div
        className={classnames('wrapper-input', className, {
          disabled: isDisabled,
          isIcon: !!icon,
        })}
      >
        <div className='input-container'>
          <input
            className={classnames({ error: errors && objectValue })}
            type={type}
            id={`${name}${disabled ? '-disabled' : ''}`}
            autoComplete='off'
            disabled={isDisabled}
            placeholder={placeholder}
            maxLength={args.maxLength}
            defaultValue={defaultValue as string}
            pattern={args.pattern as string}
            required={args.required}
            {...register(name, {
              required,
              maxLength,
              valueAsNumber: valueAsNumber as false,
              pattern,
              validate,
              ...prepareInputData(setValue, name, trigger, onChange),
              ...registerOptions,
            })}
          />
          {icon && (
            <div className='icon' onClick={handleClickIcon}>
              {icon}
            </div>
          )}
        </div>
        {!!label && (
          <label htmlFor={name}>
            {label}
            {args.required && <sup>*</sup>}
          </label>
        )}
        {errors && objectValue && <span className='error'>{objectValue?.message}</span>}
      </div>
    </>
  );
};
